import {AbstractComponentElement} from "../AbstractComponentElement";
import {
    ComponentCategory,
    ComponentElementManifest,
    ComponentElementProperty
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import * as React from "react";
import {
    BaseStateModel,
    ComponentElement, ComponentElementDisplayMode,
    ComponentElementStatic
} from "@bizform/type/model/component_element/ComponentElement.model";
import {Static} from "@bizform/type/decorator/Static.decorator";
import {ComponentElementClass, ReactComponentElementInit} from "@bizform/core/dist/js/bizflow/core.min";
import {ComponentHelper, Debug} from "@bizform/helper/dist/js/bizflow/helper.min";
import {DataType} from "@bizform/type/model/model/DataType.model";
import {User} from "@bizform/type/model/data_type/User.model";
import {I18n} from "../../misc/model/I18n.model";
import {UserUI} from "../../misc/addon/UserUI";

type Props = {};

type WrappedCompState = {
    // attribute
    name: string;
    email?: string;
    id?: string;
    loginId?: string;
    nameClass?: string;
    nameStyle?: object;
    showButton: boolean;
    // event
};

type WrappedFormState = {
};

type State = BaseStateModel & {
    wrappedCompState: WrappedCompState;
    wrappedFormState: WrappedFormState;
};

@ComponentElementClass()
@Static<ComponentElementStatic<User>>()
export class BfUser extends AbstractComponentElement<Props, State> {
    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_dHHQR2o3PClbP5SwBiCuKL9Mmb29k75",
        category: ComponentCategory.MISC,
        label: I18n.componentElement.user.label,
        description: I18n.componentElement.user.description,
        icon: "",
        dataType: [DataType.USER],
        property: null
    };

    setProperty(property: ComponentElementProperty): void {
        try {
            const newState = ComponentHelper.createStateWithProperties<State, React.FormEvent<HTMLInputElement>>(property, this);
            this.setState(newState);
        } catch (e) {
            this.emitDidCatch(e);
        }
    }

    @ReactComponentElementInit(BfUser)
    static init(): ComponentElement<User> {
        return;
    }

    initDone(): void {
    }

    destroy(): void {
        // proceed something to clean up
        this.destroyDone();
    }

    destroyDone(): void {
    }

    /* for React */
    props: Props;
    state: State;

    constructor(props?: Props) {
        super(props);

        this.state = {
            show: false,
            displayMode: ComponentElementDisplayMode.INIT,
            wrappedCompState: {
                name: "",
                showButton: true
            },
            wrappedFormState: {}
        };
    }

    emitDidCatch(error: Error | any): void {
        Debug.console.error(error);
    }

    subscription(value: User) {
        const newState = {
            wrappedCompState: {
                ...this.state.wrappedCompState
            }
        };
        if (value) {
            if (value.name) {
                newState.wrappedCompState.name = value.name;
            }
            if (value.email) {
                newState.wrappedCompState.email = value.email;
            }
            if (value.loginId) {
                newState.wrappedCompState.loginId = value.loginId;
            }
            if (value.id) {
                newState.wrappedCompState.id = value.id;
            }

            this.setState(newState);
        }
    }

    render(): React.ReactNode {
        const {
            show,
            displayMode
        } = this.state;

        if (!show) {
            return null;
        } else {
            switch (displayMode) {
                case ComponentElementDisplayMode.EDIT:
                case ComponentElementDisplayMode.READONLY:
                case ComponentElementDisplayMode.DISABLED:
                case ComponentElementDisplayMode.PRINT:
                    return this._render();
                default:
                    return null;
            }
        }
    }

    _render() {
        return (
            <React.Fragment>
                <UserUI
                    name={this.state.wrappedCompState.name}
                    email={this.state.wrappedCompState.email}
                    loginId={this.state.wrappedCompState.loginId}
                    id={this.state.wrappedCompState.id}
                    nameClass={this.state.wrappedCompState.nameClass}
                    nameStyle={this.state.wrappedCompState.nameStyle}
                    showButton={this.state.wrappedCompState.showButton}
                />
            </React.Fragment>
        );
    }
}

